<template>
  <div class="animated fadeIn">
    <b-tabs>
      <b-tab title="Samples">
        <SubmissionSampleTable :submission="submission" />
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import SubmissionSampleTable from './SubmissionSampleTable.vue';

export default {
  name: 'SubmissionDetailCardstack',
  components: {
    SubmissionSampleTable
  },
  props: {
    submission: {
      type: Object,
      default () {
        return null
      }
    }
  }
}
</script>
